export const Target = ({ color = 'currentColor', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12.0005"
      cy="11.9946"
      r="3.09615"
      stroke={color}
      strokeWidth="1.5"
    ></circle>
    <circle
      cx="12.0002"
      cy="12.0051"
      r="6.17308"
      stroke={color}
      strokeWidth="1.5"
    ></circle>
    <circle cx="12" cy="12" r="9.25" stroke={color} strokeWidth="1.5"></circle>
  </svg>
);
